const ALLOWED_NAME = /[^\p{L}\p{N} _.\-]/gu;
const NAME_MIN = 2;
const NAME_MAX = 16;

export function sanitizeDisplayName(raw: unknown): string | null {
  if (typeof raw !== 'string') return null;
  const normalized = raw
    .normalize('NFKC')
    .replace(/[\u0000-\u001f\u007f\u200b-\u200f\u2028-\u202f]/g, '')
    .replace(ALLOWED_NAME, '')
    .replace(/\s+/g, ' ')
    .trim();
  const length = [...normalized].length;
  if (length < NAME_MIN || length > NAME_MAX) return null;
  return normalized;
}

export function displayNameFromEmail(email: string): string {
  const prefix = email.split('@')[0] ?? 'SUBJECT';
  const cleaned = sanitizeDisplayName(prefix.replace(/[^\p{L}\p{N} _.\-]/gu, ' '));
  return cleaned ?? 'SUBJECT';
}

export function sanitizeRoomCode(raw: unknown): string | null {
  if (typeof raw !== 'string') return null;
  const code = raw.trim().toUpperCase();
  if (!/^[ABCDEFGHJKLMNPQRSTUVWXYZ23456789]{6}$/.test(code)) return null;
  return code;
}
